import { Action } from "../global/Action";
import { ActionCentre } from "../global/ActionCentre";
import { Actions, IAction, IPopupSettings } from "../global/types";

declare var _gaq: any;

export class StayedHere {
    private actionCentre: ActionCentre;
    private settings: IPopupSettings;
    private hasSomenoneStayedHere: boolean = false;

    constructor(actionsService: ActionCentre) {
        const hasSomenoneStayedHereElement: HTMLElement = document.querySelector("[data-page-has-expert]") as HTMLElement;

        if (hasSomenoneStayedHereElement) {
            this.hasSomenoneStayedHere = hasSomenoneStayedHereElement.getAttribute("data-page-has-expert") === "True";
        }

        this.actionCentre = actionsService;

        this.runBindings();

        if (this.hasSomenoneStayedHere) {
            _gaq.push(["_trackEvent", "Interaction", "Speak to an expert SHOWN", document.URL, 0, false]);
        }
    }

    private runBindings(): void {
        const trigger: HTMLElement = document.querySelector("[data-expert-open]") as HTMLElement;
        const popup: HTMLElement = document.querySelector("[data-expert-popup]") as HTMLElement;
        const close: HTMLElement = document.querySelector("[data-expert-close]") as HTMLElement;
        const overlay: HTMLElement = document.querySelector("[data-overlay]") as HTMLElement;

        popup.addEventListener("click", (e) => {
            e.stopPropagation();
        });

        trigger.addEventListener("click", (e) => {
            e.stopPropagation();

            const showAction = new Action(Actions.SHOW_OVERLAY, ["showOverlay", true]);
            this.actionCentre.Do(showAction);
             
            this.showPopup();

            if (this.hasSomenoneStayedHere) {
                _gaq.push(["_trackEvent", "Interaction", "Speak to an expert TRIGGERED", document.URL, 0, false]);
            } else {
                _gaq.push(["_trackEvent", "Interaction", "Call for free advice", document.URL, 0, false]);
            }

        });

        close.addEventListener("click", (e) => {
            e.stopPropagation();

            const hideAction = new Action(Actions.HIDE_OVERLAY, ["showOverlay", false]);
            this.actionCentre.Do(hideAction);

            this.hidePopup();
        });

        overlay.addEventListener("click", (e) => {
            const hideAction = new Action(Actions.HIDE_OVERLAY, ["showOverlay", false]);
            this.actionCentre.Do(hideAction);

            this.hidePopup();
        });
    }

    private showPopup(): void {
        const trigger: HTMLElement = document.querySelector("[data-expert-open]") as HTMLElement;
        const popup: HTMLElement = document.querySelector("[data-expert-popup]") as HTMLElement;

        trigger.classList.add("active");
        popup.style.display = "block";
    }

    private hidePopup(): void {
        const trigger: HTMLElement = document.querySelector("[data-expert-open]") as HTMLElement;
        const popup: HTMLElement = document.querySelector("[data-expert-popup]") as HTMLElement;

        trigger.classList.remove("active");
        popup.style.display = "none";
    }

}



// WEBPACK FOOTER //
// ./src/hotels/StayedHere.ts